import React, { Component } from "react";
import {
  List,
  Edit,
  Datagrid,
  TextField,
  ReferenceField,
  Button,
  ReferenceInput,
  EditButton,
  GET_ONE,
  BooleanField,
  DateField,
  ImageField,
  BooleanInput,
  AutocompleteInput,
  SelectInput,
  Toolbar,
  SaveButton,
  SimpleForm,
  Filter,
  TextInput,
  useTranslate
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Modal from "react-responsive-modal";
import { makeStyles } from "@mui/styles";
import myDataProvider from "../myRestProvider";
import noImage from "./../images/combined-shape.svg";
import moment from "moment";
import { CREATE } from "ra-core";
import { getLocalStorageKey } from "../common/common";
import CopyText from "../globs/utils/copyText";

const StatusField = ({ record = {}, source }) => (
  <span>{record[source] === null ? "-" : record[source] ? "Yes" : "No"}</span>
);

const selectInputStyle = {
  width: 200,
};

const useStyles = makeStyles({
  textContent: {
    whiteSpace: "pre-wrap",
  },
});

const PostFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput source="material_code" defaultValue="" />
      <TextInput source="name" defaultValue="" />
    </Filter>
  );
};

const styles = {
  image: {
    height: 50,
    width: 50,
  },
};

const ProductImagesList = (props) => {
  const classes = useStyles();
  const translate = useTranslate();


  return (
    <Scrollbars className="scroll-container">
      <List
        {...props}
        filters={<PostFilter />}
        sort={{ field: "created_at", order: "DESC" }}
        title={translate('resources.productsmaster.fields.product_images')}
        exporter={false}
      >
        <Datagrid bulkActionButtons={false}>
          <EditButton 
          source="edit"
           />
          <DateField
            source="updated_at"
            // label="Upload Timestamp"
            showTime
            sortable={false}
          />
          <ImageField
            source="image_data"
            title="Uploaded Image"
            // label="Uploaded Image"
          />
          <TextField source="name" allowEmpty />
          <TextField source="material_code" allowEmpty />
          {/* <CopyText source="id" label=" " sortable={false} /> */}
          <TextField
            className={classes.textContent}
            source="material_description"
            allowEmpty
          />
        </Datagrid>
      </List>
    </Scrollbars>
  );
};

export default ProductImagesList;
